import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  Divider,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { ChevronRight, ExpandMore } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const ChildrenCard = ({
  items,
  Icon,
  title,
  Item,
  isExpanded,
  setIsExpanded,
  onEdit,
}) => {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader
        sx={{
          backgroundColor: theme => theme.palette.secondary.main,
          padding: '8px 4px 8px 8px',
          cursor: items.length > 0 ? 'pointer' : 'default',
          ':hover': {
            backgroundColor: theme => theme.palette.secondary.light,
          },
        }}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          items.length > 0 && setIsExpanded(prev => !prev);
        }}
        title={
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            justifyContent="space-between"
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Icon fontSize="small" />
              <Typography variant="body2" fontWeight="bold">
                {t(`components.location.${title}`, {
                  count: items.length,
                })}
              </Typography>
            </Stack>
            {items.length > 0 && (
              <IconButton size="small">
                {isExpanded ? (
                  <ExpandMore fontSize="small" sx={{ color: 'white' }} />
                ) : (
                  <ChevronRight fontSize="small" sx={{ color: 'white' }} />
                )}
              </IconButton>
            )}
          </Stack>
        }
      />
      <Collapse in={isExpanded} unmountOnExit timeout="auto">
        <CardContent sx={{ padding: '0 !important' }}>
          {items.map((item, index) => (
            <Fragment key={item.properties.id}>
              <Item key={item.properties.id} item={item} onEdit={onEdit} />
              {index + 1 < items.length && (
                <Box px="10px">
                  <Divider
                    sx={{
                      borderColor: theme => theme.palette.primary.main,
                      width: '100%',
                      borderBottomWidth: 1,
                      opacity: 0.5,
                    }}
                  />
                </Box>
              )}
            </Fragment>
          ))}
        </CardContent>
      </Collapse>
    </Card>
  );
};

ChildrenCard.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  Item: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  setIsExpanded: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default ChildrenCard;
